module.exports = __webpack_public_path__ + "static/img/xinNew2.d2b8773.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xinNew2.jpg
// module id = KTar
// module chunks = 0